// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3C28l","label":"styles_label__3UIFe"};